"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../utils");
var _constant = require("../../../../constant");
var _ = require("../../..");
var _styled = require("../../../base/styled");
var _styled2 = require("../styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FlightGuide = function FlightGuide(_ref) {
  var company = _ref.company,
    open = _ref.open,
    onCollapse = _ref.onCollapse,
    isValid = _ref.isValid,
    showValidateIcon = _ref.showValidateIcon;
  return /*#__PURE__*/_react.default.createElement(_.Collapsible, {
    id: _constant.companySection.FLIGHT_GUIDE,
    onCollapse: onCollapse,
    title: "Flight guide to success",
    open: open.flightGuide,
    isValid: isValid,
    showValidateIcon: showValidateIcon
  }, (company.talentGuide || company.talentGuideLink) && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Next Generation of Talent Statement"), /*#__PURE__*/_react.default.createElement(_styled.PreformattedText, null, company.talentGuide), /*#__PURE__*/_react.default.createElement(_styled2.Anchor, {
    $bsStyle: {
      marginBottom: '0px'
    },
    href: company.talentGuideLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, (0, _utils.getUrlWithoutProtocol)(company.talentGuideLink))), (company.recruit || company.undergraduateLink) && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Recruitment Efforts: Timelines, Programs & Structure"), /*#__PURE__*/_react.default.createElement(_styled.PreformattedText, null, company.recruit), /*#__PURE__*/_react.default.createElement(_styled2.Anchor, {
    $bsStyle: {
      marginBottom: '0px'
    },
    href: company.undergraduateLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, (0, _utils.getUrlWithoutProtocol)(company.undergraduateLink))), company.careerRunways && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "How to Prep & Succeed"), /*#__PURE__*/_react.default.createElement(_styled.PreformattedText, null, company.careerRunways)));
};
FlightGuide.propTypes = {
  company: _utils.companyProps.isRequired,
  open: _utils.opportunitySectionsProps.isRequired,
  onCollapse: _propTypes.default.func.isRequired,
  isValid: _propTypes.default.bool.isRequired,
  showValidateIcon: _propTypes.default.bool
};
FlightGuide.defaultProps = {
  showValidateIcon: false
};
var _default = FlightGuide;
exports.default = _default;